<template>
  <transition name="fade">
    <div class="balance" v-if="visible">
      <div class="balance-shadow" @click="hideCoinBalancePopup"></div>
      <div class="balance-main">
        <a
          href="javascript:;"
          class="main-close"
          @click="hideCoinBalancePopup"
        ></a>
        <div class="main-content">
          <p class="title">{{ letter.tips }}</p>
          <p class="cur">
            <span class="cur-title">{{ getCoinsName }}{{ letter.remain }}</span>
            <span class="cur-coin">{{
              curCoinAmount >= 0 ? curCoinAmount : 0
            }}</span>
            <span class="cur-unit">{{ curCoinCurrency }}</span>
          </p>
          <p class="tip">{{ letter.balanceNotEnoughExpiry }}</p>
          <div class="btn">
            <a
              href="javascript:;"
              class="btn-change"
              @click="hideCoinBalancePopup"
              >{{ letter.chooseOtherPay }}</a
            >
            <a href="javascript:;" class="btn-pay" @click="openService">{{
              letter.contactService
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import contactService from '@mixins/officialWebStore/contactService';
export default {
  name: 'CoinsBalancePopup',
  mixins: [contactService],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      curCoinAmount: state => state.coins.curCoinAmount,
      curCoinCurrency: state => state.coins.curCoinCurrency,
      letter: state => state.letter,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      serverId: state => state.serverId,
      roleId: state => state.roleId
    }),
    ...mapGetters(['getCoinsName', 'isJpPlatform'])
  },
  methods: {
    hideCoinBalancePopup() {
      this.$emit('update:visible', false);
    },
    openService() {
      this.isJpPlatform ? this.jpService() : this.openGlobalService({
        gameId: this.gameId,
        roleId: this.roleId,
        roleName: this.roleName,
        serverId: this.serverId,
        isUidLogin: this.isUidLogin,
        uid: this.uid,
        loginAccount: this.loginAccount
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.balance {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 708px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }

  .main {
    &-close {
      position: absolute;
      right: 32px;
      top: 27px;
      background: url($tmslgImg + 'close.png') no-repeat;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
    &-content {
      .title {
        font-size: 26px;
        text-align: center;
        line-height: 86px;
        height: 86px;
        @include g-popup-title();
        border-radius: 10px 10px 0 0;
        margin: 0;
      }
      .cur {
        margin: 105px auto 30px;
        text-align: center;
        color: #333;
        > span {
          display: inline-block;
        }
        &-title {
          font-size: 34px;
        }
        &-coin {
          margin-right: 10px;
          font-size: 56px;
          color: #c1a15e;
        }
        &-unit {
          font-size: 30px;
        }
      }
      .tip {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: #333;
      }
      .btn {
        display: flex;
        justify-content: center;
        margin: 105px auto;
        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 244px;
          box-sizing: border-box;
          font-size: 24px;
          height: 80px;
          color: #fff;
          border-radius: 10px;
          padding: 0 10px;
          cursor: pointer;
        }
        &-pay {
          background: $popupSubBtn;
        }
        &-change {
          background: $btnBg;
          margin-right: 26px;
        }
      }
    }
  }
}
</style>
